export default __webpack_public_path__ + "static/media/JUSTICE FOR TARA.7b507a16.png";